<template>
  <RcContentSplit>
    <template #content-left>
      <img
        src="/src/assets/img/illustrations/chameleon_rocket_combined.svg"
        class="rc-chameleon-rocket-combined rc-illustration"
        alt=""
      />
    </template>

    <template #content-right>
      <!-- If we know the subscriber -->
      <template v-if="subscriber">
        <!-- Susbscriber can connect by email -->
        <div
          v-if="
            subscriber.email_domains.length && !subscriber.remote_key_access
          "
        >
          <RcAuthLogin
            @loginError="handleError"
            :domains="subscriber.email_domains"
          >
          </RcAuthLogin>
          <!-- If Proxy or Access Points -->
          <div
            v-if="subscriber.proxy_urls.length || subscriber.access_points"
            class="rc-divider-or"
          >
            <div class="rc-divider-or--line"></div>
            <div class="rc-divider-or--text">{{ $t("common.or") }}</div>
            <div class="rc-divider-or--line"></div>
          </div>
          <template v-if="subscriber.proxy_urls.length">
            <a
              :href="subscriber.proxy_urls[0]"
              class="btn btn-lg btn-outline-secondary mx-auto rc-btn-proxy"
              ><RcIcon name="proxy" scale="1.5"></RcIcon
              ><span v-html="$t('auth.subscriber.access.proxy_connect')"></span
            ></a>
          </template>
          <template v-else-if="subscriber.access_points">
            <div class="rc-intro">
              <p
                class="mb-4"
                v-html="$t('auth.subscriber.access.visit_institution')"
              ></p>
              <div>
                <strong>{{ subscriber.name }}</strong>
              </div>
              <div>{{ subscriber.address_1 }}</div>
              <div>{{ subscriber.address_2 }}</div>
              <div>
                {{ subscriber.city }}, {{ subscriber.state }},
                {{ subscriber.country }}
              </div>
              <div>{{ subscriber.zip }}</div>
            </div>
          </template>
        </div>

        <!-- Susbscriber cannot connect by email -->
        <div v-else>
          <!-- Only proxy and/or access point -->
          <template v-if="subscriber.proxy_urls.length">
            <h1>{{ $t(`auth.log.in`) }}</h1>
            <div class="rc-intro">
              <p>
                {{ $t("auth.subscriber.access.connect_via_website") }}
                <strong>{{ subscriber.name }}</strong
                >.
              </p>
            </div>
            <a
              :href="subscriber.proxy_urls[0]"
              class="btn btn-lg btn-outline-secondary mx-auto rc-btn-proxy"
              ><RcIcon name="proxy" scale="1.5"></RcIcon
              ><span v-html="$t('auth.subscriber.access.proxy_connect')"></span
            ></a>
            <template v-if="subscriber.access_points">
              <div class="rc-divider-or">
                <div class="rc-divider-or--line"></div>
                <div class="rc-divider-or--text">{{ $t("common.or") }}</div>
                <div class="rc-divider-or--line"></div>
              </div>
              <div class="rc-intro">
                <p
                  class="mb-4"
                  v-html="$t('auth.subscriber.access.visit_institution')"
                ></p>
                <div>
                  <strong>{{ subscriber.name }}</strong>
                </div>
                <div>{{ subscriber.address_1 }}</div>
                <div>{{ subscriber.address_2 }}</div>
                <div>
                  {{ subscriber.city }}, {{ subscriber.state }},
                  {{ subscriber.country }}
                </div>
                <div>{{ subscriber.zip }}</div>
              </div>
            </template>
          </template>

          <!-- Only physical access -->
          <template v-else-if="subscriber.access_points">
            <h1>{{ $t("auth.subscriber.access.via_institution") }}</h1>

            <div class="rc-intro">
              <p
                class="mb-4"
                v-html="$t('auth.subscriber.access.visit_institution')"
              ></p>
              <div>
                <strong>{{ subscriber.name }}</strong>
              </div>
              <div>{{ subscriber.address_1 }}</div>
              <div>{{ subscriber.address_2 }}</div>
              <div>
                {{ subscriber.city }}, {{ subscriber.state }},
                {{ subscriber.country }}
              </div>
              <div>{{ subscriber.zip }}</div>
            </div>
          </template>

          <!-- If nothing -->
          <template v-else>
            <h1>{{ $t("auth.subscriber.access.no_result.title") }}</h1>
            <div class="rc-intro">
              <h2 class="h4 mt-4">{{ subscriber.name }}</h2>
              <p>
                {{ $t("auth.subscriber.access.no_result.intro") }}
              </p>

              <p>
                {{ $t("auth.subscriber.access.no_result.intro_2") }}
                <a :href="$t('auth.subscriber.access.no_result.url_old_curio')">
                  {{ $t("auth.subscriber.access.no_result.url_old_curio") }}
                </a>
              </p>

              <p>
                {{ $t("auth.subscriber.access.no_result.help_center.1") }}
                <a
                  :href="$t('auth.subscriber.access.no_result.help_center.url')"
                >
                  {{ $t("nav.help_desk") }}</a
                >
                {{ $t("auth.subscriber.access.no_result.help_center.2") }}
              </p>
            </div>
          </template>
        </div>
      </template>
      <!-- Default -->
      <template v-else>
        <RcAuthLogin
          @loginError="handleError"
          :domains="
            profile.organisation_domains ? profile.organisation_domains : []
          "
        >
          <template v-slot:link>
            <div
              v-if="!profile.organisation_domains"
              class="rc-link-get-started"
            >
              <router-link :to="toGetStarted">
                {{ $t("auth.get_started.link") }}
              </router-link>
            </div>
          </template>

          <template v-slot:providers>
            <a
              @click="logout"
              :href="toGoogleAuth"
              class="btn btn-lg rc-btn-login"
              ><img
                src="/src/assets/img/icons/ic_google.svg"
                alt=""
                aria-hidden="true"
              />{{ $t("auth.log.in_with") }} Google</a
            >
            <a
              @click="logout"
              :href="toMicrosoftAuth"
              class="btn btn-lg rc-btn-login"
              ><img
                src="/src/assets/img/icons/ic_microsoft.svg"
                alt=""
                aria-hidden="true"
              />{{ $t("auth.log.in_with") }} Microsoft</a
            >
          </template>
        </RcAuthLogin>
      </template>
    </template>
  </RcContentSplit>
</template>

<script>
import Config from "#/config";
import { mapState } from "vuex";
import RcContentSplit from "#/layout/components/ContentSplit.vue";
import { navMixin } from "#/routes/mixins";
import RcAuthLogin from "@/libvue/apps/auth/Login.vue";
import RcIcon from "@/libvue/components/icons/Base.vue";
import { AUTH_LOGOUT } from "@/libvue/apps/auth/actions";
import { SET_SUBSCRIBER } from "@/libvue/apps/subscribers/actions";

export default {
  name: "RcSiteLogin",
  components: {
    RcAuthLogin,
    RcContentSplit,
    RcIcon
  },
  mixins: [navMixin],

  data() {
    return {
      apiHost: Config.apiHost()
    };
  },
  computed: {
    ...mapState({
      ipToken: (state) => state.auth.ipToken.data,
      verifyToken: (state) => state.auth.verify.data,
      profile: (state) => state.auth.user,
      subscriber: (state) => state.subscribers.detail.data
    }),
    nextUrl() {
      return this.$route.query.redirect
        ? this.$route.query.redirect
        : `/${this.$i18n.locale}/${this.$t("nav.home")}`;
    },
    toGoogleAuth() {
      return `${this.apiHost}/allauth/google/login/?next=${this.nextUrl}`;
    },
    toMicrosoftAuth() {
      return `${this.apiHost}/allauth/microsoft/login/?next=${this.nextUrl}`;
    },
    imgOpenSchool() {
      return this.$i18n.locale == "fr"
        ? "/img/icons/lg_ecole_ouverte.png"
        : "/img/icons/lg_open_school.png";
    },
    geoLoc() {
      return window.geoip_region();
    }
  },
  methods: {
    handleError(e) {
      if (e.status_code == 403) {
        this.$router.push({
          name: "schoolNotFound",
          params: { locale: this.$i18n.locale }
        });
      }
    },
    logout() {
      this.$store.dispatch(AUTH_LOGOUT);
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit(SET_SUBSCRIBER, null);
    next();
  }
};
</script>
<style lang="scss">
.rc-form-email {
  margin-bottom: 0.5rem !important;
  small.form-text.text-secondary {
    margin-bottom: 1rem;
  }
}
</style>
